
    import React from 'react';
    import ProductFormPageContainer from './ProductFormPageContainer';
    
    export class ProductFormPage extends React.Component{
        render(){
            return (
                <ProductFormPageContainer {...this.props}/>
            )
        }
    }
    